import { styled } from '@mui/system';

export const List = styled('ul')({
	width: '100%',
	margin: 0,
	padding: 0,
	display: 'flex',
	flexDirection: 'column',
	gap: '8px',
});
